$(document).ready(function($) {
  $(document).on('click', 'a[href="#copy-link"]', function(e) {
    e.preventDefault();
    let url = $(this).data('url') ? $(this).data('url') : window.location.href; 
    navigator.clipboard.writeText(url);
    navHandler.displayToast('Link copied to clipboard.');
  });
});
